import { AnimationItem } from 'lottie-web';
import React, { useEffect, useRef } from 'react';
import { useDynamicImport } from '../../hooks/useDynamicImport';

type LottieProps = {
  animation: LottieAnimation;
  className?: string;
};

export type LottieAnimation = {
  url: string;
  altText?: string;
};

const Lottie: React.FC<LottieProps> = ({ animation, className }) => {
  const ref = useRef<HTMLDivElement>(null);
  const lottie = useDynamicImport(() =>
    import('lottie-web' /* webpackChunkName: "lottie" */)
  );

  useEffect(() => {
    let animationItem: AnimationItem;

    if (lottie && ref.current) {
      animationItem = lottie.default.loadAnimation({
        container: ref.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: animation.url,
        rendererSettings: {
          className,
        },
      });
    }

    return () => animationItem?.destroy();
  }, [lottie, animation.url, animation.altText, className, ref]);

  return <div aria-label={animation.altText} ref={ref} />;
};

export default Lottie;
